// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3RrPV","ScrollX":"Scroll_ScrollX__2F6fD","ScrollY":"Scroll_ScrollY__lgMuB"};